import { APP_INITIALIZER, NgModule } from '@angular/core';
import { MatDateFormats } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { AssetsI18nLoader, SiteService } from '@sla-ng/core';
import { ITemporalDateFormat } from './utils/temporal-date-adapter';
import { GlobalConfigService } from './services/global-config.service';
import { filter, firstValueFrom, take } from 'rxjs';

export function initI18n(i18n: AssetsI18nLoader): () => Promise<void> {
    return (): Promise<void> => i18n.init(null, 'ui-material');
}

export const MOMENT_DATE_FORMAT: MatDateFormats = {
    parse: {
        dateInput: 'sla-ui-material.parse.dateInput',
    },
    display: {
        dateInput: 'sla-ui-material.display.dateInput',
        monthYearLabel: 'sla-ui-material.display.monthYearLabel',
        dateA11yLabel: 'sla-ui-material.display.dateA11yLabel',
        monthYearA11yLabel: 'sla-ui-material.display.monthYearA11yLabel',
    },
};

export const ADVANCED_DATE_FORMAT: MatDateFormats = {
    parse: {
        dateInput: 'sla-ui-material.parse.dateInput',
    },
    display: {
        dateInput: 'sla-ui-material.display.dateInput',
        monthYearLabel: 'sla-ui-material.display.monthYearLabel',
        dateA11yLabel: 'sla-ui-material.display.dateA11yLabel',
        monthYearA11yLabel: 'sla-ui-material.display.monthYearA11yLabel',
    },
};


export const temporalDateInput: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
};

export const temporalMonthYearLabel: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
};

export const TEMPORAL_DATE_FORMAT: ITemporalDateFormat = {
    parse: {
        dateInput: temporalDateInput,
    },
    display: {
        dateInput: temporalDateInput,
        monthYearLabel: temporalMonthYearLabel,
        dateA11yLabel: temporalDateInput,
        monthYearA11yLabel: temporalMonthYearLabel,
    },
};

export function initGlobalConfig(siteService: SiteService, globalConfigService: GlobalConfigService): () => Promise<void> {
    return async (): Promise<void> => {
        await firstValueFrom(siteService.subConfig().pipe(filter((val: boolean) => val), take(1)));
        await firstValueFrom(globalConfigService.loadGlobalConfig().pipe(take(1)));
    };
}
// @dynamic
@NgModule({
    declarations: [],
    imports: [
        MatIconModule,
    ],
    exports: [],
    providers: [
        { provide: APP_INITIALIZER, useFactory: initI18n, deps: [ AssetsI18nLoader ], multi: true },
        { provide: APP_INITIALIZER, useFactory: initGlobalConfig, deps: [ SiteService, GlobalConfigService ], multi: true },
    ],
})
export class UIMaterialModule {}
